module.exports = __webpack_public_path__ + "static/media/soy.99c87b60.png";